import 'babel-polyfill'
import React from 'react'
import { render } from 'react-dom'
import registerServiceWorker from './registerServiceWorker'
import configureStore from './redux/configureStore'
import Root from './domains/Root'
import { getSession } from './redux/modules/session'
// import { getTrendingTopics } from './redux/modules/search'
import {getEntryTopicTitles} from './redux/modules/entryTopicTitles'
import {fetchTopicFlatMap} from './redux/modules/topicFlatMap'
import {initSentry} from './util/sentry'
import './core/less/index.css'

initSentry()
const store = configureStore()
store.dispatch(getSession()).then(() => {
  store.dispatch(getEntryTopicTitles())
  // Fectching trending now only happens after user clicks on search bars,
  // speeding up page load time.
  //store.dispatch(getTrendingTopics());
  store.dispatch(fetchTopicFlatMap())
  render(<Root store={store} />, document.getElementById('root'))
})

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js